module.exports = __webpack_public_path__ + "static/media/banner1.0440c07f.png";